import { create } from 'zustand';
import { getQueryParam } from '../../../../utils/urls';

interface ReferralStore {
  referralId: string | undefined;
  initializeReferralId: () => void;
}

export const useReferralStore = create<ReferralStore>((set, get) => ({
  referralId: undefined,
  initializeReferralId: () => {
    const refId = getQueryParam('ref_id');
    const currentRefId = get().referralId;
    if (refId) {
      if (refId === currentRefId) {
        return;
      }
      set({ referralId: refId });
    }
  },
}));
